import { createInjectionKey as e } from "./ghl-ui.es896.js";
const c = e("n-date-picker");
export {
  c as datePickerInjectionKey
};
